import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../Hooks/useAuth";

export function useGuideReport() {
  const [data, setData] = useState(null);
  const [Id, setId] = useState(null);
  const [details, setDetails] = useState(false);
  const [preview, setPreview] = useState(false);
  const [isToastOpen, setIsToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState({
    title: "",
    variation: "",
  });
  const [orderFilter, setOrderFilter] = useState(null);
  const [filteredDataLength, setFilteredDataLength] = useState(0);
  const [secondaryFilter] = useState("");
  const [dateFilter, setDateFilter] = useState(null);
  const [modalNameFilter, setModalNameFilter] = useState({
    isOpen: false,
    data: null,
    isUsing: null,
  });
  const [modalItineraryFilter, setModalItineraryFilter] = useState({
    isOpen: false,
    data: null,
    isUsing: null,
  });
  const [modalTypeFilter, setModalTypeFilter] = useState({
    isOpen: false,
    data: null,
    isUsing: null,
  });

  const timerRef = useRef(0);
  const navigate = useNavigate();
  const { currentUserData, logout } = useAuth();

  useEffect(() => {
    if (currentUserData && currentUserData.role === "user") {
      (async () => {
        await logout();
        navigate("/admin/login");
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function toggleToast(isOpen) {
    setIsToastOpen(isOpen);
  }

  function onToastOpen(title, variation) {
    setToastMessage({ title: title, variation: variation });
    toggleToast(false);
    window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(function () {
      toggleToast(true);
    }, 100);
  }

  function OpenDetails(rowId) {
    setId(rowId);
    setDetails(true);
  }

  function CloseDetails() {
    setDetails(false);
  }

  function OpenModal(rowIsBlocked, rowId, rowName) {
    setData({
      Id: rowId,
      active: rowIsBlocked,
      Name: rowName,
    });
  }

  return {
    data,
    setData,
    Id,
    details,
    preview,
    setPreview,
    isToastOpen,
    toastMessage,
    orderFilter,
    setOrderFilter,
    filteredDataLength,
    setFilteredDataLength,
    secondaryFilter,
    dateFilter,
    setDateFilter,
    modalNameFilter,
    setModalNameFilter,
    modalItineraryFilter,
    setModalItineraryFilter,
    modalTypeFilter,
    setModalTypeFilter,
    toggleToast,
    onToastOpen,
    OpenDetails,
    CloseDetails,
    OpenModal,
  };
}
